














import { defineComponent } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import QuestionnaireForm from '@/components/organisms/questionnaire/QuestionnaireForm.vue'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { UserGetters } from '@/store/user/getters'
import { CreateQuestionnaireDto } from '../../../api/@types'
import { QuestionnaireActions } from '@/store/questionnaire/actions'

export default defineComponent({
  name: 'NewQuestionnaire',
  components: { Layout, QuestionnaireForm },
  setup(props, context) {
    const { user } = useGetters<UserGetters>('user', ['user'])
    const { createQuestionnaire } = useActions<QuestionnaireActions>(
      'questionnaire',
      ['createQuestionnaire'],
    )

    const isAutomatic = context.root.$route.path.includes('automatic')

    const save = async (body: CreateQuestionnaireDto) => {
      await createQuestionnaire({
        ...body,
        createdById: (user && user.value?.id) || -1,
      })
      context.root.$router.push('/' + (isAutomatic ? 'automatic' : 'manual'))
    }

    const cancel = () => {
      const path = context.root.$route.path.replace('/new', '')
      context.root.$router.push(path)
    }
    return { user, save, isAutomatic, cancel }
  },
})
